function mobileMenuButtons2025(menuId) {

    const mobileMenuBtn = document.querySelector('.navbar_mobile[aria-controls="' + menuId + '"]');
    const mobileMenuCloseBtn = document.querySelector('.close-menu[aria-controls="' + menuId + '"]');
    const navOpenClass = 'nav_open';

    if (mobileMenuBtn) {
        mobileMenuBtn.addEventListener('click', function () {

            if (document.documentElement.classList.contains(navOpenClass)) {
                document.documentElement.classList.remove(navOpenClass);
                this.setAttribute('aria-expanded', 'false');
                this.setAttribute('aria-label', this.dataset.collapsed);
            } else {
                document.documentElement.classList.add(navOpenClass);
                this.setAttribute('aria-expanded', 'true');
                this.setAttribute('aria-label', this.dataset.expanded);
            }
        });
    }

    if (mobileMenuCloseBtn) {
        mobileMenuCloseBtn.addEventListener('click', function () {

            if (document.documentElement.classList.contains(navOpenClass)) {
                document.documentElement.classList.remove(navOpenClass);

                if (mobileMenuBtn) {
                    mobileMenuBtn.setAttribute('aria-expanded', 'false');
                    mobileMenuBtn.setAttribute('aria-label', mobileMenuBtn.dataset.collapsed);
                }
            }
        });
    }

    const mobileBackButton = document.querySelector('.menu-back-level[aria-controls="' + menuId + '"]');
    if (mobileBackButton) {
        mobileBackButton.addEventListener('click', function () {
            const openedLevel = document.querySelectorAll('#' + menuId + ' .lvl-1-open');
            if (openedLevel.length > 0) {
                openedLevel.forEach(level => {
                    level.classList.remove('lvl-1-open');
                })
            }
            document.body.dataset.menuLevel = '';
            const levelMenuContainer = document.getElementById('menu-level-container');
            levelMenuContainer.innerHTML = '';
        });
    }
}

function mobileMenuLevels() {
    const MOBILE_MENU_BREAKPOINT = parseInt(getComputedStyle(document.body).getPropertyValue('--mobile-menu-breakpoint')) || 1180;
    const levelMenuContainer = document.getElementById('menu-level-container');

    function mobileMenuItemClick (e) {
        const isMobileMenu = window.matchMedia('(max-width: ' + MOBILE_MENU_BREAKPOINT + 'px)').matches;

        if (!isMobileMenu) {
            return;
        }

        e.preventDefault();

        for (let i = this.parentNode.parentNode.children.length - 1; i >= 0; i--) {
            if (this.parentNode.parentNode.children[i] === this.parentNode) {
                document.body.dataset.menuLevel = 'open';
                this.parentNode.classList.add('lvl-1-open');
                const subMenu = this.parentNode.querySelector('.e-menu-tab-content');
                levelMenuContainer.innerHTML = subMenu.innerHTML;
                continue;
            }
            this.parentNode.parentNode.children[i].classList.remove('lvl-1-open');
        }

    }

    const topLevelMenuItems = document.querySelectorAll('.e-tabbed-menu .e-menu-tab > span');
    if (topLevelMenuItems.length) {
        for (let i = topLevelMenuItems.length - 1; i >= 0; i--) {
            topLevelMenuItems[i].addEventListener('click', mobileMenuItemClick);
        }
    }
}

function desktopMenu2025() {
    const MOBILE_MENU_BREAKPOINT = 1180;

    const isMobile = () => {
        return window.matchMedia('(max-width: ' + MOBILE_MENU_BREAKPOINT + 'px)').matches;
    };

    let currentTab;
    document.querySelectorAll('[role="tab"]').forEach(tab => {
        tab.addEventListener('mouseover', function(event) {
            if (isMobile()) {
                return;
            }

            const selectedTab = event.currentTarget;
            const prevState = selectedTab.getAttribute('aria-selected');
            const tabList = selectedTab.closest('[role="tablist"]');
            const tabs = tabList.querySelectorAll('[role="tab"]');
            const panels = tabList.querySelectorAll('[role="tabpanel"]');

            tabs.forEach(t => {
                if (t === selectedTab) {
                    currentTab = t;
                    return;
                }
                t.setAttribute('aria-selected', 'false');
                t.setAttribute('tabindex', '-1');
            });

            panels.forEach(p => {
                if ( p === selectedTab.nextElementSibling ) {
                    return;
                }
                p.hidden = true
            });

            if (prevState === 'true') {
                //document.body.classList.remove('menu-dropdown-open');
                return;
            }

            selectedTab.setAttribute('aria-selected', 'true');
            selectedTab.setAttribute('tabindex', '0');
            selectedTab.nextElementSibling.hidden = false;
            document.body.classList.add('menu-dropdown-open');
        });
    });

    function hideMenu(tab) {
        if (!tab) {
            return;
        }

        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
        tab.nextElementSibling.hidden = true;
        document.body.classList.remove('menu-dropdown-open');
        currentTab = null;
    }

    const outsideMenu = document.querySelectorAll('.logo, .e-header-ctas, .e-tabbed-menu-spacer, .site-content--flow');

    outsideMenu.forEach(
        elem => {
            elem.addEventListener('mouseover', function() {
                if (isMobile()) {
                    return;
                }
                if (currentTab) {
                    hideMenu(currentTab);
                }
            });
        }
    );
}

export default function eToroMenu2025() {
    const menuId = 'e-menu-2025';
    const menu = document.getElementById(menuId);
    if (!menu) {
        return;
    }
    desktopMenu2025();

    mobileMenuLevels(menuId);
    mobileMenuButtons2025(menuId);
}